import React, { useEffect } from 'react';
import useThumbStorage from '../hooks/useThumbStorage';


const ThumbProgressBar = ({file, setThumb, genre, imgUrl, setImgUrl}) => {
    const {url, progress} = useThumbStorage(file, genre, imgUrl);
    
    useEffect(() => {
        if (url){
            setImgUrl(null);
            setThumb(null);
        }
    }, [url, setThumb, setImgUrl])

    return (
        <div>
            Thumbnail
            <div className="progress-bar" style={{"border": "1px solid black", "backgroundColor": "white", "height": "15px"}}>
                <div style={{"width": progress + '%', "height": "100%", "backgroundColor": "#90be4e"}}>
                    <p style={{"textAlign": "center", "color": "black", "fontSize": "15px"}}>{Math.floor(progress)}</p>
                </div>
            </div>
            <br />
        </div>
    );
}


export default ThumbProgressBar;